module.exports = __webpack_public_path__ + "media/images/views/lp/client/choose-sourcedout/client-benefit-01-8325931fc604bdea01b660e1a7420038.png";